/**
 * List Schema of Carga
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'

/* TODO: review generated schema */
export class ListCargaSchema extends Schema {
  readonly name = 'ListCarga'

  readonly fieldSet: FieldSet<Carga> = {
    idCargaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    sistema1: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.sistema1?.$id,
      },
    }),
    sistema2: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.sistema2?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    auditoria: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.auditoria?.$id,
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.endereco?.$id,
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    tipoOcorrencia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.tipoOcorrencia?.$id,
      },
    }),
    posicaoMotorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.posicaoMotorista?.$id,
      },
    }),
    responsavelFilial1: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavelFilial1?.$id,
      },
    }),
    responsavelFilial2: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavelFilial2?.$id,
      },
    }),
    sistema3: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.sistema3?.$id,
      },
    }),
    sistema4: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.sistema4?.$id,
      },
    }),
    statusCarga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.statusCarga?.$id,
      },
    }),
    tipoPessoaRecebedor: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.tipoPessoaRecebedor?.$id,
      },
    }),
    danfe: (): FieldComponent => ({
      is: Component.Render,
    }),
    nroNotaFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
    finalizadoViaWeb: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.finalizadoViaWeb),
      },
    }),
    reprocessarRedesul: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.reprocessarRedesul),
      },
    }),
    processouEasyDoc: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.processouEasyDoc),
      },
    }),
    qtdPaleteEntregue: (): FieldComponent => ({
      is: Component.Render,
    }),
    qtdPaleteRetirado: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeRecebedor: (): FieldComponent => ({
      is: Component.Render,
    }),
    documentoRecebedor: (): FieldComponent => ({
      is: Component.Render,
    }),
    rgRecebedor: (): FieldComponent => ({
      is: Component.Render,
    }),
    idCargaApp: (): FieldComponent => ({
      is: Component.Render,
    }),
    codigoBarra: (): FieldComponent => ({
      is: Component.Render,
    }),
    placaVeiculo: (): FieldComponent => ({
      is: Component.Render,
    }),
    tipoVeiculo: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeMotorista: (): FieldComponent => ({
      is: Component.Render,
    }),
    serialNumber: (): FieldComponent => ({
      is: Component.Render,
    }),
    cte: (): FieldComponent => ({
      is: Component.Render,
    }),
    protocolSsw: (): FieldComponent => ({
      is: Component.Render,
    }),
    sigla: (): FieldComponent => ({
      is: Component.Render,
    }),
    cpfMotorista: (): FieldComponent => ({
      is: Component.Render,
    }),
    cdCorreio: (): FieldComponent => ({
      is: Component.Render,
    }),
    xpedido: (): FieldComponent => ({
      is: Component.Render,
    }),
    distanciaParaDestinoEmMetros: (): FieldComponent => ({
      is: Component.Render,
    }),
    duracaoParaDestinoEmSegundos: (): FieldComponent => ({
      is: Component.Render,
    }),
    pontoReferenciaEntrega: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataEmissaoDanfe: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataEmissaoDanfe),
      },
    }),
    dataInicioEntrega: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataInicioEntrega),
      },
    }),
    dataFinalizacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataFinalizacao),
      },
    }),
    observacao: (): FieldComponent => ({
      is: Component.Render,
    }),
    latitudeEntrega: (): FieldComponent => ({
      is: Component.Render,
    }),
    longitudeEntrega: (): FieldComponent => ({
      is: Component.Render,
    }),
    devolvida: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.devolvida),
      },
    }),
    latitudeCheckIn: (): FieldComponent => ({
      is: Component.Render,
    }),
    longitudeCheckIn: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCheckIn: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCheckIn),
      },
    }),
    dataPrevisao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataPrevisao),
      },
    }),
    possuiDanfe: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.possuiDanfe),
      },
    }),
    criadoViaPainel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.criadoViaPainel),
      },
    }),
    dataBaixaSistema: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataBaixaSistema),
      },
    }),
    dataRemocao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataRemocao),
      },
    }),
    distanciaCheckInEmMetros: (): FieldComponent => ({
      is: Component.Render,
    }),
    distanciaEntregaEmMetros: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
